import { DocumentPage, type DocumentSection } from "@/pages/DocumentPage";

const privacySections: DocumentSection[] = [
  {
    title: "1. 수집하는 개인정보 항목",
    items: [
      "소셜 로그인 식별값: 카카오, 네이버 등 로그인 제공자의 사용자 고유 식별자",
      "서비스 이용 과정에서 자동 수집되는 정보: 접속 IP, 기기 정보, 브라우저 또는 앱 정보, 접속 일시, 이용 기록",
      "이용자가 서비스 내에서 직접 작성하는 정보: 게시글, 댓글, 문의 내용, 기타 입력 콘텐츠",
    ],
    body: "서비스는 이름, 휴대전화번호, 주소와 같은 추가 개인정보를 별도로 요구하지 않습니다. 다만 소셜 로그인 제공자 정책에 따라 전달되는 정보 범위는 달라질 수 있습니다.",
  },
  {
    title: "2. 개인정보의 수집 및 이용 목적",
    items: [
      "회원 식별, 로그인 처리, 계정 관리",
      "커뮤니티, 포트폴리오, AI 기능 등 서비스 제공",
      "부정 이용 방지, 보안 관리, 서비스 안정성 확보",
      "오류 확인, 이용 통계 분석, 서비스 개선",
      "이용자 문의 대응 및 공지사항 전달",
    ],
  },
  {
    title: "3. 개인정보의 보유 및 이용 기간",
    items: [
      "회원 정보는 회원 탈퇴 시까지 보관합니다.",
      "게시글, 댓글 등 이용자가 직접 작성한 콘텐츠는 서비스 운영 및 법령 준수를 위해 탈퇴 후에도 관련 법령 또는 내부 정책에 따라 일정 기간 보관될 수 있습니다.",
      "접속 로그 등 운영 기록은 관련 법령 또는 내부 기준에 따라 일정 기간 보관 후 삭제합니다.",
      "수집 및 이용 목적이 달성되면 지체 없이 삭제하거나 복구가 불가능한 방식으로 파기합니다.",
    ],
  },
  {
    title: "4. 개인정보의 제3자 제공",
    body: "서비스는 이용자의 개인정보를 외부에 판매하거나 제3자에게 제공하지 않습니다. 다만 법령에 특별한 규정이 있거나 수사기관 등의 적법한 요청이 있는 경우에는 예외가 발생할 수 있습니다.",
  },
  {
    title: "5. 개인정보 처리 위탁",
    body: "서비스는 안정적인 운영을 위해 클라우드 또는 인프라 제공업체를 이용할 수 있으며, 이 경우 관련 법령에 따라 필요한 보호조치를 적용합니다.",
  },
  {
    title: "6. 이용자의 권리",
    items: [
      "이용자는 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지를 요청할 수 있습니다.",
      "회원 탈퇴를 원하는 경우 서비스 내 기능 또는 아래 문의처를 통해 요청할 수 있습니다.",
    ],
  },
  {
    title: "7. 개인정보 보호를 위한 조치",
    body: "서비스는 개인정보의 안전한 처리를 위해 접근 통제, 인증 관리, 로그 관리 등 필요한 보호조치를 적용하기 위해 노력합니다.",
  },
  {
    title: "8. 문의처",
    body: "개인정보 관련 문의: devggyul@gmail.com",
  },
  {
    title: "9. 시행일",
    body: "본 방침은 2026년 4월 12일부터 적용됩니다.",
  },
];

export function PrivacyPolicyPage() {
  return (
    <DocumentPage
      eyebrow="Privacy Policy"
      title="개인정보처리방침"
      description={'앤트(이하 "서비스")는 이용자의 개인정보를 중요하게 생각하며, 서비스 제공에 필요한 범위 내에서 최소한의 개인정보를 처리합니다.'}
      sections={privacySections}
    />
  );
}
